import React from "react";
import { Modal, ModalHeader, ModalBody, Card, CardBody, UncontrolledTooltip } from "reactstrap";
import DataTable from "react-data-table-component";
import { getNotasDePedidoCategory } from "../../../services/notasDePedidoServices";
import useFetcher from "../../../hooks/useFetcher";
import { BlurSpinner } from "../../../components/BlurSpinner";
import { getEstadoByValue } from "../../../components/CandidatosNP/utils";
import { useAuth } from "../../../context/AuthContext";
import modulos from "../../../mocks/modulos";

const ProcesosModal = ({ toggle, isOpen, info, history }) => {
  const { currentUser } = useAuth();
  const isAdmin = currentUser.haveAdminAccess(modulos.NOTAS_DE_PEDIDO);

  const [categories, isLoadingCategories] = useFetcher(getNotasDePedidoCategory, undefined);
  const estadosCandidatos = categories && categories.estadoCandidatoNP;
  const { relsCandidatosNP, candidato } = info;
  const sucursalesAsignadas = currentUser && currentUser.user.sucursalesAsignadas.map((s) => s.itemId);

  const hasSucursalAccess = (nota) => {
    const { sucursalId } = nota;
    if (isAdmin) return false;

    return !sucursalesAsignadas.includes(sucursalId);
  };
  const handleClickedNotaId = (id) => {
    if (!id) return;
    history.push({
      pathname: `/notasDePedido/${id}/detail/`,
    });
  };

  return (
    <Modal isOpen={isOpen} centered size="lg" style={{ fontFamily: "Nunito", maxWidth: "1000px" }}>
      <ModalHeader toggle={toggle} style={{ borderBottom: "none", background: "white" }}>
        <h6 style={{ fontFamily: "Nunito" }}>
          Procesos en los que participa <span className="font-weight-bold">{`${candidato.nombre} ${candidato.apellido}`}</span>
        </h6>
      </ModalHeader>
      <ModalBody className="p-0" style={{ alignItems: "flex-start" }}>
        <BlurSpinner loading={isLoadingCategories}>
          <Card className="p-0 mx-auto w-100">
            <CardBody className="p-2 pt-0 w-100">
              <DataTable
                noHeader
                noDataComponent={
                  <div className="p-3">
                    <b>No se encontraron procesos</b>
                  </div>
                }
                // onRowClicked={(row) => handleRowClick(row)}
                data={relsCandidatosNP}
                columns={[
                  {
                    name: "id",
                    selector: (row) => (
                      <>
                        <UncontrolledTooltip trigger="hover" target={`id${row.notaDePedido.id}`}>
                          ir a la nota
                        </UncontrolledTooltip>
                        <button
                          id={`id${row.notaDePedido.id}`}
                          type="button"
                          className="btn btn-link p-1"
                          onClick={() => handleClickedNotaId(row.notaDePedido.id)}
                          disabled={hasSucursalAccess(row.notaDePedido)}
                        >
                          <p className="m-0">{row.notaDePedido.id}</p>
                        </button>
                      </>
                    ),
                    center: true,
                    style: {
                      cursor: "pointer",
                    },
                    width: "70px !important",
                    compact: true,
                  },
                  {
                    name: "Sucursal",
                    selector: (row) =>
                      row.notaDePedido.sucursal ? (
                        <>
                          <UncontrolledTooltip target={`sucursal${row.id}`}>{row.notaDePedido.sucursal.titulo || row.notaDePedido.sucursal.title}</UncontrolledTooltip>
                          <div data-tag="allowRowEvents" id={`sucursal${row.id}`}>
                            {row.notaDePedido.sucursal.titulo || row.notaDePedido.sucursal.title}
                          </div>
                        </>
                      ) : (
                        "-"
                      ),
                    center: true,
                    width: "190px !important",
                    style: {
                      cursor: "pointer",
                      textAlign: "center",
                    },
                  },
                  {
                    name: "Cliente",
                    selector: (row) =>
                      row.notaDePedido.razonSocial ? (
                        <>
                          <UncontrolledTooltip target={`sucursal${row.id}`}>{row.notaDePedido.razonSocial}</UncontrolledTooltip>
                          <div data-tag="allowRowEvents" id={`sucursal${row.id}`}>
                            {row.notaDePedido.razonSocial}
                          </div>
                        </>
                      ) : (
                        "-"
                      ),
                    center: true,
                    width: "190px !important",
                    style: {
                      cursor: "pointer",
                      textAlign: "center",
                    },
                  },
                  {
                    name: "Posición",
                    selector: (row) =>
                      row.notaDePedido.posicion ? (
                        <>
                          <UncontrolledTooltip target={`sucursal${row.id}`}>{row.notaDePedido.posicion}</UncontrolledTooltip>
                          <div data-tag="allowRowEvents" id={`sucursal${row.id}`}>
                            {row.notaDePedido.posicion}
                          </div>
                        </>
                      ) : (
                        "-"
                      ),
                    center: true,
                    width: "190px !important",
                    style: {
                      cursor: "pointer",
                      textAlign: "center",
                    },
                  },
                  {
                    name: "Cargo",
                    selector: (row) =>
                      row.notaDePedido.cargo ? (
                        <>
                          <UncontrolledTooltip target={`sucursal${row.id}`}>{row.notaDePedido.cargo}</UncontrolledTooltip>
                          <div data-tag="allowRowEvents" id={`sucursal${row.id}`}>
                            {row.notaDePedido.cargo}
                          </div>
                        </>
                      ) : (
                        "-"
                      ),
                    center: true,
                    width: "190px !important",
                    style: {
                      cursor: "pointer",
                      textAlign: "center",
                    },
                  },
                  {
                    name: "Estado",
                    selector: (row) => (row.estado ? getEstadoByValue(row.estado, estadosCandidatos && estadosCandidatos.type) : "-"),
                    center: true,
                    style: {
                      cursor: "pointer",
                    },
                    width: "100px !important",
                    compact: true,
                  },
                ]}
              />
            </CardBody>
          </Card>
        </BlurSpinner>
      </ModalBody>
    </Modal>
  );
};

export default ProcesosModal;
